/* istanbul ignore file */
import { logger } from '@/repositories/Logger'

export default {
  install (Vue, options) {
    Vue.prototype.$logger = logger
  }
}
